import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import ReportSuperSet from './reports';
import ReportingDashboard from './report-detail';

const ReportsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ReportSuperSet />} />
  </ErrorBoundaryRoutes>
);

export default ReportsRoutes;
